import { render, staticRenderFns } from "./JobStatusList.vue?vue&type=template&id=0bf86f05&"
import script from "./JobStatusList.vue?vue&type=script&lang=js&"
export * from "./JobStatusList.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusList.vue?vue&type=style&index=0&id=0bf86f05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports